import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Star, CheckCircle } from 'lucide-react';
export function HeroSection() {
  return <section className="relative overflow-hidden bg-[#FFF8F0] pt-12 pb-20 lg:pt-24 lg:pb-32" data-id="element-125">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 rounded-full bg-[#E8614D] opacity-5 blur-3xl" data-id="element-126"></div>
      <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-80 h-80 rounded-full bg-[#D4A853] opacity-5 blur-3xl" data-id="element-127"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-128">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-129">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-center lg:text-left" data-id="element-130">
            <div className="inline-flex items-center gap-2 bg-[#E8614D]/10 px-4 py-2 rounded-full mb-6" data-id="element-131">
              <span className="text-lg" data-id="element-132">🔥</span>
              <span className="text-[#E8614D] font-semibold text-sm sm:text-base" data-id="element-133">
                +200 mamás latinas ya están editando
              </span>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#2D1B0E] leading-tight mb-6" data-id="element-134">
              Gana <span className="text-[#E8614D]" data-id="element-135">$500/Semana</span> Editando
              Videos Desde Tu Celular
            </h1>

            <p className="text-lg sm:text-xl text-[#2D1B0E]/80 mb-8 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-136">
              El sistema probado para mamás latinas en USA: edita Reels desde
              celular, cobra $20-50 cada uno en 24h sin mostrar tu cara.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start" data-id="element-137">
              <motion.a whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} href="#precio-final" className="w-full sm:w-auto px-8 py-4 bg-[#E8614D] text-white text-lg font-bold rounded-full shadow-lg hover:shadow-xl transition-all flex items-center justify-center gap-2" data-id="element-138">
                ¡Quiero Empezar Ahora! — $6.36
                <ArrowRight className="w-5 h-5" data-id="element-139" />
              </motion.a>
            </div>

            <div className="mt-4 flex items-center justify-center lg:justify-start gap-2 text-sm text-[#2D1B0E]/70" data-id="element-140">
              <CheckCircle className="w-4 h-4 text-[#1A6B5C]" data-id="element-141" />
              <span data-id="element-142">Descarga instantánea · PDF + Templates + Prompts</span>
            </div>
          </motion.div>

          {/* Image Content */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-143">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl border-4 border-white transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-144">
              <img src="https://cdn.magicpatterns.com/uploads/mUzqWQaHTqjjEHn1hYYhSU/FREELANCE_LATINA.png" alt="Freelance Latina trabajando desde casa" className="w-full h-auto object-cover" data-id="element-145" />

              {/* Floating Badge */}
              <div className="absolute bottom-6 left-6 bg-white/95 backdrop-blur-sm p-4 rounded-2xl shadow-lg border border-[#E8614D]/20 max-w-[200px]" data-id="element-146">
                <div className="flex items-center gap-2 mb-1" data-id="element-147">
                  <div className="flex -space-x-2" data-id="element-148">
                    {[1, 2, 3].map(i => <div key={i} className="w-8 h-8 rounded-full bg-gray-200 border-2 border-white flex items-center justify-center text-xs font-bold text-[#2D1B0E]" data-id="element-149">
                        {i === 3 ? '+' : ''}
                      </div>)}
                  </div>
                  <div className="flex text-[#D4A853]" data-id="element-150">
                    <Star className="w-4 h-4 fill-current" data-id="element-151" />
                    <Star className="w-4 h-4 fill-current" data-id="element-152" />
                    <Star className="w-4 h-4 fill-current" data-id="element-153" />
                  </div>
                </div>
                <p className="text-xs font-medium text-[#2D1B0E]" data-id="element-154">
                  "¡Primeros $20 ganados hoy!"
                </p>
              </div>
            </div>

            {/* Decorative elements */}
            <div className="absolute -z-10 top-10 -right-10 w-24 h-24 bg-[#D4A853] rounded-full opacity-20 blur-xl" data-id="element-155"></div>
            <div className="absolute -z-10 -bottom-10 -left-10 w-32 h-32 bg-[#1A6B5C] rounded-full opacity-20 blur-xl" data-id="element-156"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}